"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.function.name");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getTagData = getTagData;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

function getHtmlData(content, tag) {
  var parser = new DOMParser();
  var htmlTags = parser.parseFromString(content, 'text/html').querySelectorAll(tag);
  var res = [];
  (0, _forEach.default)(htmlTags).call(htmlTags, function (el) {
    var content = el.innerHTML;
    var tagData = {
      content: content
    };
    var attributes = el.attributes;

    if (attributes && attributes.length > 0) {
      var _context;

      (0, _forEach.default)(_context = (0, _from.default)(attributes)).call(_context, function (att) {
        var _context2, _context3;

        var name = (0, _includes.default)(_context2 = att.name).call(_context2, '-') ? (0, _map.default)(_context3 = att.name.split('-')).call(_context3, function (n, i) {
          if (i >= 1) {
            var _context4;

            n = (0, _concat.default)(_context4 = "".concat(n.charAt(0).toUpperCase())).call(_context4, (0, _slice.default)(n).call(n, 1));
          }

          return n;
        }).join('') : att.name;
        tagData[name] = att.value;
      });
    }

    res.push(tagData);
  });
  return res;
}

function getTagData(data, tags) {
  var _context5;

  var res = [];
  (0, _forEach.default)(_context5 = data.hits.hits).call(_context5, function (article) {
    var _context6, _context9;

    var articleData = {
      url: article._source.url,
      title: (0, _includes.default)(_context6 = article._index).call(_context6, 'rsnotes') && article._source.releaseNotesTitle ? article._source.releaseNotesTitle : article._source.title
    };

    if (article._source.appcapabilities && article._source.appcapabilities.length > 0) {
      var _context7;

      var appCapabilities = [];
      (0, _forEach.default)(_context7 = article._source.appcapabilities).call(_context7, function (tag) {
        var _context8;

        var tagData = getHtmlData(tag, 'APPCAPABILITY');
        appCapabilities = (0, _concat.default)(_context8 = []).call(_context8, (0, _toConsumableArray2.default)(appCapabilities), (0, _toConsumableArray2.default)(tagData));
      });
      articleData.appCapabilities = appCapabilities;
    }

    if (tags && tags.length > 0) {
      var _article$_source$tagg;

      var content = (_article$_source$tagg = article._source.taggedContent) !== null && _article$_source$tagg !== void 0 ? _article$_source$tagg : article._source.content;
      (0, _forEach.default)(tags).call(tags, function (tag) {
        var tagData = getHtmlData(content, tag);
        articleData[tag] = tagData;
      });
    }

    res = (0, _concat.default)(_context9 = []).call(_context9, (0, _toConsumableArray2.default)(res), [articleData]);
  });
  return res;
}
